import {html} from 'lit';
import {customElement, state} from 'lit/decorators.js';
import B2bElement from '../../../../b2b-element.js';
import defaultStyle from '../../../b2b-public-styles.scss';
import B2bPublicServiceClientProxy from '../../../../gen/com/arabellesolutions/sdc/b2b/pub/B2bPublicServiceClientProxy.js';

@customElement('b2b-public-forgot-password')
export class B2bPublicForgotPassword extends B2bElement {
  static styles = [defaultStyle];

  /** @type {String} */
  @state()
  accessor __email = {
    email: ''
  };

  __b2bPublicServiceProxy = new B2bPublicServiceClientProxy(super.msgpackClientPublic());

  /**
   * @param {String} entry
   * @return {Promise<boolean>}
   */
  __submit = entry => this.__b2bPublicServiceProxy.sendPasswordResetEmail(entry.email);

  render() {
    return html`
      <mta-page-title page-name="forgotPassword" title="Forgot Password"></mta-page-title>
      <div class="page-container">
        <mta-form
            .value="${this.__email}"
            @keydown="${this.__onKeyDown}"
            success-message="A password reset link has been sent to your email.">
          <div class="menu-top-left">
            <common-mta-logo class="logo" url=""></common-mta-logo>
          </div>
          <div class="form-header">
            <h2>Forgot Password</h2>
            <p>Please enter your email, and a password reset link will be sent to you.</p>
          </div>
          <div class="line">
            <mta-form-input name="email" label="Enter the email address" required></mta-form-input>
          </div>
          <mta-form-buttons hide-cancel="true" submit-label="Forgot Password" .submit="${this.__submit}"></mta-form-buttons>
          <p><mta-icon icon="arrow_back"></mta-icon><a href="#/auth/login">Back to Login</a></p>
        </mta-form>
      </div>
    `;
  }

  __onKeyDown(e) {
    if (e.keyCode === 13) {
      const form = this.shadowRoot.querySelector("mta-form");
      const buttons = this.shadowRoot.querySelector("mta-form-buttons");

      form.resetStateHistory();
      buttons.submit(this.__email);
    }
  }

  connectedCallback() {
    super.connectedCallback();
    if (!this.__submit) {
      this.redirect('#/auth/login');
    }
  }
}
